import { api as axios } from "../../../../shared/axios";
import useSWR from "swr";
import { API_URL } from "../../../../shared/config";

const fetcher = (url) => axios.get(url);

export const createTransaction = async (data, config = {}) => {
  try {
    const request = await axios.post(`${API_URL}/data-source/uploads/`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return { data: request.data, error: undefined };
  } catch (error) {
    return { data: undefined, error: error };
  }
};

export const useGetTransaction = (companyId) => {
  const { data, error, mutate } = useSWR(
    `${API_URL}/data-source/transactions/?company_id=${companyId}`,
    fetcher
  );
  return {
    singleItem: data?.data,
    isLoadingSingleItem: !error && !data,
    isErrorSingleItem: error,
    mutateItem: mutate,
  };
};

export const useGetTransactionById = (id) => {
  const { data, error } = useSWR(
    `${API_URL}/data-source/transactions/${id}/`,
    fetcher
  );
  return {
    itemById: data?.data,
    isLoadingItemById: !error && !data,
    isErrorItemById: error,
  };
};

export const useGetDetailsTransaction = (id) => {
  const { data, error } = useSWR(
    `${API_URL}/data-source/transactions/detail-training-ml/${id}/`,
    fetcher
  );
  return {
    details: data?.data,
    isLoadingDetails: !error && !data,
    isErrorDetails: error,
  };
};

export const createTrainingMl = async (data, id) => {
  try {
    const request = await axios.post(
      `${API_URL}/data-source/transactions/detail-training-ml/${id}/`,
      data
    );
    return { data: request.data, error: undefined };
  } catch (error) {
    return { data: undefined, error: error };
  }
};

export const useGetAITraining = (companyId, plantId) => {
  const { data, error, mutate } = useSWR(
    `${API_URL}/data-source/transactions/ai-training/?company_id=${companyId}&plant_id=${plantId}`,
    fetcher,
    { revalidateOnFocus: false }
  );
  return {
    singleItem: data?.data,
    isLoadingSingleItem: !error && !data,
    isErrorSingleItem: error,
    mutateItem: mutate,
  };
};

export const createAITraining = async (data) => {
  try {
    const request = await axios.post(
      `${API_URL}/data-source/transactions/ai-training/`,
      data
    );
    return { data: request.data, error: undefined };
  } catch (error) {
    return { data: undefined, error: error };
  }
};

export const useGetPolygonData = (billId, blobUrl) => {
  const { data, error, mutate } = useSWR(
    billId && blobUrl
      ? `${API_URL}/data-source/transactions/ocr-polygon/?bill_id=${billId}&blob_url=${encodeURIComponent(
          blobUrl
        )}`
      : null,
    fetcher,
    { revalidateOnFocus: false }
  );
  return {
    polygonData: data?.data,
    isLoadingPolygonData: !error && !data,
    isErrorPolygonData: error,
    mutatePolygonData: mutate,
  };
};
